/**
 * @generated SignedSource<<e7127373be572e719da95965c399da3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_ReleaseFlyout$data = {
  readonly description: string | null | undefined;
  readonly doneIssues: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly driver: {
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly inprogressIssues: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly project: {
    readonly avatar: {
      readonly __typename: "JiraAvatar";
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly name: string;
    readonly projectTypeName: string | null | undefined;
  } | null | undefined;
  readonly releaseDate: AGG$DateTime | null | undefined;
  readonly startDate: AGG$DateTime | null | undefined;
  readonly status: JiraVersionStatus | null | undefined;
  readonly todoIssues: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly versionId: string;
  readonly " $fragmentType": "ui_ReleaseFlyout";
};
export type ui_ReleaseFlyout$key = {
  readonly " $data"?: ui_ReleaseFlyout$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_ReleaseFlyout">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "totalCount"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_ReleaseFlyout",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "startDate"
    },
    {
      "kind": "ScalarField",
      "name": "releaseDate"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "versionId"
    },
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            },
            {
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "projectTypeName"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "driver",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "alias": "doneIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "statusCategories": "DONE"
          }
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "issues(filters:{\"statusCategories\":\"DONE\"})"
    },
    {
      "alias": "inprogressIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "statusCategories": "IN_PROGRESS"
          }
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "issues(filters:{\"statusCategories\":\"IN_PROGRESS\"})"
    },
    {
      "alias": "todoIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "statusCategories": "TODO"
          }
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "issues(filters:{\"statusCategories\":\"TODO\"})"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "4c7630af902d2c6fc6957ae33d4ad778";

export default node;
